import LeadershipProfile from "../../components/LeadershipProfile"
import SEO from "../../components/SEO";

export default function BoardOfDirectors() {
  const boardSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Board of Directors",
    "url": "https://www.thrombio.com.au/leadership/board-of-directors",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "Organization",
      "name": "Thrombio",
      "description": "Thrombio is a drug discovery company dedicated to advancing the global standard of care for the treatment of stroke using novel anti-thrombotic drugs with unprecedented safety and efficacy."
    }
  };
  
  return (
    <div className="boardOfDirectorsBg">
      <SEO
        title="Board of Directors"
        description="ThromBio's Board of Directors includes Paul Hopper, David Mazzo, and founder Shaun Jackson, bringing decades of experience in biotech, healthcare, and life sciences."
        keywords={['Board of Directors', 'Paul Hopper', 'David Mazzo', 'Shaun Jackson', 'Biotech Leadership', 'Corporate Governance']}
        ogImage="/paulHopper.webp"
        schema={boardSchema}
      />

      <div className="px-12 pt-40 md:pt-[150px] xl:pt-[186px] xl:page-width xl:px-0">
        <div className="flex flex-col gap-4 md:gap-16">
          {/* Optimized H1 tag that preserves layout */}
          <div className="text-[4.8rem] font-bold leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            <h1 className="sr-only">Leadership Team: Driving Innovation in Stroke Care</h1>
            Leadership
          </div>
          {/* Optimized H2 tag that preserves layout */}
          <div className="drop-shadow-[0_4px_8.9px_#000] font-syne text-[3rem] font-bold leading-[3.6rem] tracking-[.15rem]">
            <h2 className="sr-only">Board of Directors: Leading Experts in Stroke Treatment</h2>
            Board of Directors
          </div>
        </div>
      </div>
	  <div className="pt-[130px] xl:pt-[90px] xl:pb-[320px] px-16  xl:page-width xl:px-0 flex flex-col xl:grid grid-cols-3 items-center xl:items-start gap-[115px] md:gap-[75px] boardOfDirectorsBg2">
          <div className="">
            {/* Updated with optimized hidden title */}
            <LeadershipProfile
              name="Paul Hopper"
              title={<>Chairman <span className="sr-only">: Expert in Growth of Biotech, Healthcare and Life Sciences Companies</span></>}
              description="Paul Hopper has over 25 years of experience in biotech, healthcare and life sciences with a focus on start-up and rapid growth companies. He has served as either Founder, Chairman, non-executive director, or CEO, for more than 15 companies in the US, Australia and Asia."
              image="/paulHopper.webp"
            />
          </div>
          <img src="/1.2.svg" alt="Decorative divider" width={23} height={14} className="xl:hidden" />
          <div className="xl:order-1">
            {/* Updated with optimized hidden title */}
            <LeadershipProfile
              name="David Mazzo"
              title={<>Independent Director <span className="sr-only">: Expert in Pharmaceutical and Medical Device Management</span></>}
              description="Dr. David J. Mazzo is a highly accomplished and experienced pharmaceutical executive and public and private company board member who has held executive positions in both big and small Pharma globally.  He is recognized for his exceptional strategic, scientific, and regulatory expertise, upon which he has amassed a track record of almost 45 years of successful global pharmaceutical product development, registration, and launch."
              image="/davidMazzo.webp"
            />
          </div>
          <img src="/1.2.svg" alt="Decorative divider" width={23} height={14} className="xl:hidden" />
          <div className="xl:order-3">
            {/* Updated with optimized hidden title  */}
            <LeadershipProfile
              name="Shaun Jackson"
              title={<>Founder and Director <span className="sr-only">: Internationally Renowned Leading Expert in Blood Clotting Research</span></>}
              description="Shaun Jackson is a clinical academic and a National Health and Medical Research Council (NHMRC) of Australia Investigator (Leadership Level 3). He has been a faculty member at the Scripps Research Institute in La Jolla, San Diego (California, USA) since 2009 and an Honorary Visiting fellow at the University of Cambridge, UK. In 2015, he was appointed as the inaugural Director of Cardiovascular Research, at the Heart Research Institute & Charles Perkins Centre, University of Sydney. He has been the founder and director of several Australian biotechnology companies focussing on the clinical development of novel antithrombotic therapeutics."
              image="/shaunJackson.webp"
            />
          </div>
        </div>
    </div>
  );
}